function disableHover(){
	maxWidthMd(function(){
	}, function(){
		$('.js-disable-hover').on('touchstart mouseenter', function(){
			$(this).click();
		});
	});
};